<script lang="ts" setup>
import { useWorkshop } from '~/composables/cms/workshop'
import PriceCard from '~/components/workshop/price-card.vue'

const { workshop } = useWorkshop()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 md:pb-16 lg:pb-16 lg:pt-24">
    <span class="text-main-600 text-sm font-bold">{{ workshop.prices?.eyebrow }}</span>
    <Heading as="h3" size="large">{{ workshop.prices?.title }}</Heading>
    <Paragraph> {{ workshop.prices?.description }}</Paragraph>
  </Container>

  <Container
    class="xs:flex-col xs:space-x-0 xs:items-center xs:space-y-12 mx-auto flex justify-center space-x-12 pb-16 lg:flex-row lg:items-start lg:space-x-16 lg:space-y-0"
  >
    <div v-for="price in workshop.prices?.price_cards">
      <PriceCard :price="price" />
    </div>
  </Container>
</template>
